import { render } from "./GaleriaCarrossel.vue?vue&type=template&id=19d89e5c&scoped=true&ts=true"
import script from "./GaleriaCarrossel.vue?vue&type=script&lang=ts"
export * from "./GaleriaCarrossel.vue?vue&type=script&lang=ts"

import "./GaleriaCarrossel.vue?vue&type=style&index=0&id=19d89e5c&scoped=true&lang=css"
import "./GaleriaCarrossel.vue?vue&type=style&index=1&id=19d89e5c&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d89e5c"]])

export default __exports__